export function headerFunc() {
  toggleMenu()
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
  $('.l-hamburger').on('click', function() {
    $(this).toggleClass('is-open');
    $('.l-drawer').toggleClass('is-open');
  });
  $('.l-drawer__nav li a').on('click', function() {
    $('.l-hamburger').removeClass('is-open');
    $('.l-drawer').removeClass('is-open');
  });
}